<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow v-if="data.message === 'confirmation success'">
      <CCol>
        <CCardGroup class=" ml-5 content-center">
          <CCard class="p-3">
            <CCardBody>
              <form class="login" @submit.prevent="changePassword">
                <h1>SET Your Password</h1>
                <p class="text-muted=">Please set password for your account</p>

                <CInput
                  placeholder="Password"
                  type="password"
                  autocomplete="curent-password"
                  v-model="data.password" 
                  required
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  
                  
                </CInput>
                <CInput
                  placeholder="Password Confirmation"
                  type="password"
                  autocomplete="curent-password-confirmation"
                  v-model="data.password_confirmation" 
                  required
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  
                  
                </CInput>
                <hr>
                <CRow>
                  <CCol  class="text-left">
                    <p class="text-danger" v-if="data.error">{{ data.error }}</p>
                    <CButton block type="submit" color="info" class="mt-3" v-on:click.prevent="update(data.id)">Change Password</CButton>
                  </CCol>
                  
                </CRow>
              </form>
            </CCardBody> 
          </CCard>
          
        </CCardGroup>
      </CCol>
    </CRow>
    <CRow v-else>
      <div v-if="data.success">
        {{ data.message }} 
        <!-- <br><CButton color="link" class="px-0" @click="login">back to Login</CButton>  -->
      </div>
      <div v-else>
        {{ data.message }}
      </div>
      
    </CRow>
  </CContainer>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import axios from 'axios';

import user from '@/services/user'

export default {
  

    data(){
        return{
            data: {
                email: '',
                id:'',
                password: '',
                password_confirmation: '',
                remember_me: false,
                message: '',
                error: '',
                success:''
            },
        }
    },
    created() {
      this.loadData()
    },
    computed: {

    },
    methods: {
      loadData(){
        user.confirmation(this.$route.query.id)
        .then(res => {
          this.data.message = res.message
          this.data.id = res.data.iduser
        })  
      },
      update(id){
        user.setpassword(id, this.data)
        .then(res => {
          console.log(res.message)
          //if(res.message = 'set password success'){
            this.data.success = 'success'
            this.data.message = 'success set password'
          //}
        }).catch ((err) => {
          console.log(err.response.data.message)
          if(err.response.data.message = 'The given data was invalid.'){
            this.data.error = err.response.data.errors.password_confirmation[0]
          }
          // var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          // EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }, 
      login(){  
         this.$router.push({name:'Login'})          
      },     
    }
}
</script>
